export default ({ text, url }) => {
    const whatsapp = 'https://web.whatsapp.com/send?text';
    const whatsappMob = 'whatsapp://send?text';
    const inBrowser = typeof window !== 'undefined';
    const shareText = encodeURIComponent([text, url].filter(unit => Boolean(unit)).join(' '));
    const href =
        inBrowser && window.navigator.userAgent.match(/iPhone|Android/i)
            ? `${whatsappMob}=${shareText}`
            : `${whatsapp}=${shareText}`;
    return {
        href,
    };
};
